import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { searchInvoice } from "../services/agreementServices";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import JBWDateLabel from "./JBWDateLabel";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import styled from "styled-components";
import DetailsIcon from "@mui/icons-material/Details";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { SiGoogleforms } from "react-icons/si";
import { TbListDetails } from "react-icons/tb";
import { getInvoices } from "../services/InvoiceService";
import DuplicateAgreementCreateDialog from "./DuplicateAgreementCreateDialog";
import PotentialClaimsCreateDialog from "./PotentialClaimsCreateDialog";
import DuplicateClaimDialog from "./DuplicateClaimDialog";
import NewAgreementDialog from "./NewAgreementDialog";

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  "& .super-app-theme--Active": {
    backgroundColor: "#71d68e",
    "&:hover": {
      backgroundColor: "#4ECC72",
    },
  },
  "& .super-app-theme--InActive": {
    backgroundColor: "#e4c553",
    "&:hover": {
      backgroundColor: "#DEB729",
    },
  },
  "& .super-app-theme--dup": {
    backgroundColor: "#FFF8EB",
    "&:hover": {
      backgroundColor: "#FFD485",
    },
  },
}));

const InvoiceList = ({ showDealer, displayType, dealer, tenant }) => {
  const [typeValue, setTypeValue] = useState("job");
  const [searchKey, setSearchKey] = useState("");
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [infoMsg, setInfoMsg] = useState({
    msg: "Please enter Invoice Number and click on search button",
    colorCode: "#6EC207",
  });
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [openAgmDetailsDialog, setOpenAgmDetailsDialog] = useState(false);
  const [selectedAgreementId, setSelectedAgreementId] = useState(null);
  const [openPotentialClaimDialog, setOpenPotentialClaimDialog] =
    useState(false);
  const [potentialClaimData, setPotentialClaimData] = useState(null);
  const [openDuplicateClaimDialog, setOpenDuplicateClaimDialog] = useState(false);
  const [duplicateClaimData, setDuplicateClaimData] = useState(null);
  const [openNewAgreementDialog, setOpenNewAgreementDialog] = useState(false);

  const handleCloseAgmDetailsDialog = () => {
    setSelectedAgreementId(null);
    setOpenAgmDetailsDialog(false);
  };

  const handleDuplicateAgreement = (agreement) => {
    setSelectedAgreementId(agreement);
    setSelectedInvoice(null);
    setOpenDetailsDialog(false);
    setOpenAgmDetailsDialog(true);
  };

  const handleCreatePotentialClaim = (agreement) => {
    setPotentialClaimData(agreement);
    //setSelectedInvoice(null);
    setOpenDetailsDialog(false);
    setOpenPotentialClaimDialog(true);
  };

  const handleDuplicateClaimOpen = (locationAgreement) => {
    setDuplicateClaimData(locationAgreement);
    setOpenDetailsDialog(false);
    setOpenDuplicateClaimDialog(true);
  };

  const handleDuplicateClaimDialogClose = () => {
    setDuplicateClaimData(null);
    setSelectedInvoice(null);
    setOpenDuplicateClaimDialog(false);
  };

  const handleOpenNewAgreement = () => {
    setOpenDetailsDialog(false);
    setOpenNewAgreementDialog(true);
  };

  const handleNewAgreementDialogClose = () => {
    setSelectedInvoice(null);
    setOpenNewAgreementDialog(false);
  };

  const handleDetails = React.useCallback((param) => {
    console.log("Selected Invoice :", param.row);
    setSelectedInvoice({ ...param.row });
    setOpenDetailsDialog(true);
  });

  const handleCloseDetailsDialog = () => {
    setSelectedInvoice(null);
    setOpenDetailsDialog(false);
  };

  const handleCreateAgreement = React.useCallback((param) => {}); // used in columns actions (commented out)
  const handleCreatPotentialClaim = React.useCallback((param) => {});

  const columns = useMemo(
    () => [
      {
        field: "invoiceNumber",
        headerName: "Invoice #",
        width: 110,
        sortable: false,
        headerAlign: "center",
        align: "left",
      },
      {
        field: "invoiceStatus",
        headerName: "Status",
        width: 100,
        sortable: false,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "invoiceSummary",
        headerName: "Summary",
        width: 250,
        sortable: false,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "jobNumber",
        headerName: "Job ID",
        width: 100,
        sortable: false,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "firstName",
        headerName: "Customer Name",
        width: 150,
        sortable: false,
        headerAlign: "center",
        align: "center",
        enderCell: (param) => {
          return param.row.firstName + " " + param.row.lastName;
        },
      },
      {
        field: "location",
        headerName: "Location",
        width: 250,
        sortable: false,
        headerAlign: "center",
        align: "center",
        renderCell: (param) => {
          const location = param.row.locationId;

          return (
            <>
              {location && (
                <>
                  <Typography
                    variant="subtitl1"
                    component="span"
                    sx={{
                      wordWrap: "break-word",
                    }}
                    whiteSpace="normal"
                  >
                    {`${param.row.addressLine1} ${
                      param.row.addressLine2 !== null &&
                      param.row.addressLine2 !== "null"
                        ? ", " + param.row.addressLine2
                        : ""
                    }
    ${param.row.city !== null && param.row.city !== "null" ? ", " + param.row.city : ""} ${
      param.row.state !== null && param.row.state !== "null"
        ? ", " + param.row.state
        : ""
    } ${param.row.zipcode !== null && param.row.zipcode !== "null" ? ", " + param.row.zipcode : ""}.`}
                  </Typography>
                </>
              )}
            </>
          );
        },
      },
      {
        field: "stCreatedOn",
        headerName: "ST Created On",
        sortable: false,
        width: 120,
        headerAlign: "center",
        align: "center",
        renderCell: (param) => {
          if (param.value === null) return "";
          return (
            <JBWDateLabel inputDate={param.value} dateFormat="MMM.DD,YYYY" />
          );
        },
      },

      {
        field: "stModifiedOn",
        headerName: "ST Modified On",
        sortable: false,
        width: 120,
        headerAlign: "center",
        align: "center",
        renderCell: (param) => {
          if (param.value === null) return "";
          return (
            <JBWDateLabel inputDate={param.value} dateFormat="MMM.DD,YYYY" />
          );
        },
      },
      {
        field: "actions",
        type: "actions",
        headerName: "Action",
        cellClassName: "actions",
        headerAlign: "center",
        width: 150,
        align: "center",
        getActions: (params) => {
          //console.log("params", params.row);
          const agreementCreated = params.row.isAgreementCreated;

          let cellItems = [];
          //isreadyfor jwd = 0
          cellItems.push(
            <GridActionsCellItem
              icon={<TbListDetails size={20} />}
              label="Details Lookup"
              className="textPrimary"
              onClick={() => handleDetails(params)}
              color="primary"
              title="Details Lookup"
            />,
          );
          // cellItems.push(
          //   <GridActionsCellItem
          //     icon={<ReceiptLongIcon size={20} />}
          //     label="Create Agreement"
          //     className="textPrimary"
          //     onClick={() => handleCreateAgreement(params)}
          //     color="secondary"
          //     title="Create Agreement"
          //   />,
          // );
          // cellItems.push(
          //   <GridActionsCellItem
          //     icon={<SiGoogleforms size={20} />}
          //     label="Create Potential Claim"
          //     className="textPrimary"
          //     onClick={() => handleCreatPotentialClaim(params)}
          //     color="success"
          //     disabled={!agreementCreated}
          //     title="Create Potential Claim"
          //   />,
          // );
          return cellItems;
        },
        sortable: false,
      },
    ],
    [handleDetails, handleCreateAgreement, handleCreatPotentialClaim],
  );

  const handleInvoiceJobSearch = (e, overrideKey) => {
    setShowLoading(true);
    console.log("seletect tenant in search invoice", tenant);
    setErrorMsg("");
    setSearchResults(null);
    e?.preventDefault();
    setInfoMsg({
      msg: "Please wait while loading invoice data",
      colorCode: "#FCDE70",
    });
    const key = overrideKey !== undefined ? overrideKey : searchKey;
    console.log("Invoice List searchType", typeValue);
    console.log("Invoice List dealerId", dealer.dealerId);
    console.log("Invoice List searchKey", key);
    getInvoices(dealer.dealerId, 0, key).then((res) => {
      console.log("getInvoices res", res);
      if (res.data && res.data.length > 0) {
        const filtered = tenant
          ? res.data.filter((item) => item.tenantId === tenant)
          : res.data;
        if (filtered.length > 0) {
          setInfoMsg(null);
          setSearchResults(filtered);
        } else {
          setInfoMsg({ msg: "No Invoices Found", colorCode: "#B8001F" });
        }
      } else {
        setInfoMsg({ msg: "No Invoices Found", colorCode: "#B8001F" });
      }
      setShowLoading(false);
    }).catch((err) => {
      console.log("getInvoices error", err);
      setInfoMsg({ msg: "No Invoices Found", colorCode: "#B8001F" });
      setShowLoading(false);
    });
  };

  const handlePageChange = (newPage) => {
    setPage(newPage); // Update page state
    //onScrolleUp();
  };

  useEffect(() => {
    if (dealer.dealerId) {
      handleInvoiceJobSearch();
    }
  }, [dealer.dealerId, tenant]);

  const handlePotentialClaimDialogClose = () => {
    setPotentialClaimData(null);
    setSelectedInvoice(null);
    setOpenPotentialClaimDialog(false);
  };

  return (
    <>
      {openPotentialClaimDialog && (
        <PotentialClaimsCreateDialog
          openDialog={openPotentialClaimDialog}
          claimData={potentialClaimData}
          invoice={selectedInvoice}
          onClose={handlePotentialClaimDialogClose}
        />
      )}
      {/* {Duplicate Agreement} */}
      {openAgmDetailsDialog && (
        <DuplicateAgreementCreateDialog
          openAgmDetailsDialog={openAgmDetailsDialog}
          agreementId={selectedAgreementId}
          onCloseAgmDetailsDialog={handleCloseAgmDetailsDialog}
          dealer={dealer}
        />
      )}
      {openDuplicateClaimDialog && (
        <DuplicateClaimDialog
          openDialog={openDuplicateClaimDialog}
          claimData={duplicateClaimData}
          invoice={selectedInvoice}
          onClose={handleDuplicateClaimDialogClose}
        />
      )}
      {openNewAgreementDialog && (
        <NewAgreementDialog
          open={openNewAgreementDialog}
          onClose={handleNewAgreementDialogClose}
          dealer={dealer}
          tenant={tenant}
          initialSearchKey={selectedInvoice?.jobNumber}
          onCreateDuplicateAgreement={handleDuplicateAgreement}
        />
      )}
      {openDetailsDialog && (
        <InvoiceDetailsDialog
          open={openDetailsDialog}
          invoice={selectedInvoice}
          onClose={handleCloseDetailsDialog}
          onDuplicateAgreement={handleDuplicateAgreement}
          onCreatePotenitalClaim={handleCreatePotentialClaim}
          onDuplicateClaim={handleDuplicateClaimOpen}
          onCreateAgreement={handleOpenNewAgreement}
          dealer={dealer}
        />
      )}
      {(
        <Grid container>
          <Grid item xs={12}>
            {typeValue === "job" && (
              <>
                <TextField
                  id="standard-basic"
                  label="Job Number Search"
                  variant="standard"
                  sx={{ width: "15%" }}
                  value={searchKey}
                  inputProps={{ autoComplete: "off" }}
                  onChange={(e) => {
                    setSearchKey(e.target.value);
                  }}
                />
                {searchKey && (
                  <IconButton
                    aria-label="Clear search"
                    sx={{ marginTop: "15px" }}
                    onClick={() => {
                      setSearchKey("");
                      handleInvoiceJobSearch(null, "");
                    }}
                  >
                    <CloseIcon sx={{ fontSize: "20px" }} />
                  </IconButton>
                )}
                <IconButton
                  color="secondary"
                  variant="outlined"
                  aria-label="Job Number Search"
                  sx={{ marginTop: "15px" }}
                  onClick={handleInvoiceJobSearch}
                >
                  <SearchIcon sx={{ fontSize: "25px" }} />
                </IconButton>
              </>
            )}
          </Grid>
          <Grid item xs={12}>
            {showLoading === true ? (
              <Box sx={{ height: "100px" }}>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
              </Box>
            ) : (
              <StyledDataGrid
                rows={searchResults || []}
                getRowId={(row) => row.id}
                columns={columns}
                autoHeight={false}
                getRowHeight={() => "auto"}
                pageSizeOptions={[25, 50, 100]}
                paginationModel={{ page, pageSize }}
                onPaginationModelChange={(model) => {
                  handlePageChange(model.page);
                  setPageSize(model.pageSize);
                }}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 25,
                    },
                  },
                }}
                // getRowClassName={(params) => {
                //   return params.row.parentAgreementId === null
                //     ? ""
                //     : `super-app-theme--dup`;
                // }}
                disableColumnFilter={true}
                disableColumnMenu={true}
                sx={{
                  "& .muidatagrid-colcelltitle ": {
                    display: "block",
                    textAlign: "center",
                    width: "100%",
                  },
                  "& .MuiTablePagination-toolbar .MuiTablePagination-selectLabel":
                    {
                      display: "none", // Hides the "Rows per page" label
                    },
                  "& .MuiTablePagination-toolbar .MuiInputBase-root": {
                    display: "none", // Hides the dropdown
                  },
                  // height: 490,
                  // "& .MuiDataGrid-virtualScroller": {
                  //   overflowY: "auto", // Enable vertical scrolling
                  // },
                  // "& .MuiDataGrid-root": {
                  //   maxHeight: "400px", // Set max height for the entire grid
                  // },
                  // Apply custom styles to the header title container
                  "& .MuiDataGrid-columnHeaderTitleContainer": {
                    whiteSpace: "normal",
                    lineHeight: "normal",
                  },
                  // Unset the default header height to allow it to expand
                  "& .MuiDataGrid-columnHeader": {
                    height: "unset !important",
                  },
                  // Optionally, set a maxHeight for the entire header row
                  "& .MuiDataGrid-columnHeaders": {
                    maxHeight: "168px !important", // Example value
                  },
                }}
              />
            )}
          </Grid>
        </Grid>
      )}
    </>
  );

};

export default InvoiceList;

export const InvoiceDetailsDialog = (props) => {
  const {
    onClose,
    open,
    invoice,
    onDuplicateAgreement,
    onCreatePotenitalClaim,
    onDuplicateClaim,
    onCreateAgreement,
    dealer,
  } = props;

  const [selectedInvoiceAgreement, setSelectedInvoiceAgreement] =
    useState(null);
  const [selectedLocationAgreement, setSelectedLocationAgreement] =
    useState(null);

  // Data presence flags
  const hasInvoiceAgreements = invoice.invoiceAgreements?.length > 0;
  const hasClaims = invoice.invoiceClaims?.length > 0;
  const hasLocationAgreements = invoice.locationAgreements?.length > 0;
  const multipleInvoiceAgreements = invoice.invoiceAgreements?.length > 1;
  const multipleLocationAgreements = invoice.locationAgreements?.length > 1;

  // Button visibility — which button to show per condition
  // Condition 1: all null → Create Agreement. Not for a vendor dealer, the same gate as
  // AgreementsGrid's New Agreement: null (not known yet) or no dealer also hides it.
  const showCreateAgreement =
    !hasInvoiceAgreements && !hasClaims && !hasLocationAgreements &&
    dealer?.isVendorDealer === false;
  // Conditions 2 & 5: no claims, invoiceAgreements present → Duplicate Agreement
  const showDuplicateAgreement = !hasClaims && hasInvoiceAgreements;
  // Condition 3: no invoiceAgreements, no claims, locationAgreements present → Potential Claim
  const showPotentialClaim =
    !hasInvoiceAgreements && !hasClaims && hasLocationAgreements;
  // Condition 4: claims exist and locationAgreements present → Duplicate Claim
  const showDuplicateClaim = hasClaims && hasLocationAgreements;

  // Selection requirements: button is disabled until user picks a row when multiple exist
  const needInvoiceAgreementSelection =
    showDuplicateAgreement && multipleInvoiceAgreements;
  const needLocationAgreementSelection =
    (showPotentialClaim || showDuplicateClaim) && multipleLocationAgreements;

  const duplicateAgreementEnabled =
    !needInvoiceAgreementSelection || selectedInvoiceAgreement !== null;
  const potentialClaimEnabled =
    !needLocationAgreementSelection || selectedLocationAgreement !== null;
  const duplicateClaimEnabled =
    !needLocationAgreementSelection || selectedLocationAgreement !== null;

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.mlight,
      color: theme.palette.common.black,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const handleClose = (event, reason) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") {
      return;
    }
    //setSaveError("");
    onClose("close");
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      PaperProps={{
        component: "div",
      }}
      fullWidth={true}
      maxWidth={"xl"}
      disableEscapeKeyDown
    >
      <DialogTitle>Invoice #{invoice.invoiceId} Details</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Grid container spacing={2} padding={3}>
          {invoice.invoiceAgreements &&
            invoice.invoiceAgreements.length > 0 && (
              <Grid item xs={12}>
                <Paper sx={{ width: "100%", mb: 1 }} elevation={3}>
                  <Typography variant="subtitle1" sx={{ ml: 1, mb: 1 }}>
                    Agreements For Job Number
                    {needInvoiceAgreementSelection && (
                      <Typography
                        variant="caption"
                        color="warning.main"
                        sx={{ ml: 1 }}
                      >
                        — select one to proceed
                      </Typography>
                    )}
                  </Typography>
                  <Table
                    sx={{ minWidth: 550 }}
                    size="small"
                    aria-label="Agreements For Job Number"
                  >
                    <TableHead sx={{ fontSize: "10px" }}>
                      <TableRow>
                        <TableCell>Product Code</TableCell>
                        <TableCell align="left">JbwAgreementId</TableCell>
                        <TableCell align="left">Agreement Status</TableCell>
                        <TableCell align="left">Pdf URL</TableCell>
                        <TableCell align="left">
                          Agreement Purchase Date
                        </TableCell>
                        <TableCell align="left">Coverage Start Date</TableCell>
                        <TableCell align="left">Warranty Start Date</TableCell>
                        <TableCell align="left">Warranty End Date</TableCell>
                        <TableCell align="left">Is Deleted</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {invoice.invoiceAgreements.map((row, index) => (
                        <TableRow
                          key={index}
                          onClick={
                            needInvoiceAgreementSelection
                              ? () => setSelectedInvoiceAgreement(row)
                              : undefined
                          }
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            ...(needInvoiceAgreementSelection && {
                              cursor: "pointer",
                              backgroundColor:
                                selectedInvoiceAgreement === row
                                  ? "#bbdefb"
                                  : "inherit",
                              "&:hover": { backgroundColor: "#e3f2fd" },
                            }),
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {row.productCode}
                          </TableCell>
                          <TableCell align="left">
                            {row.jbwAgreementId}
                          </TableCell>
                          <TableCell align="left">
                            {row.agreementStatus}
                          </TableCell>
                          <TableCell align="left">{row.pdfURL}</TableCell>
                          <TableCell align="left">
                            {row.agreementPurchaseDate && (
                              <JBWDateLabel
                                inputDate={row.agreementPurchaseDate}
                                dateFormat="MM/DD/YYYY"
                              />
                            )}
                          </TableCell>

                          <TableCell align="left">
                            {row.coverageStartDate && (
                              <JBWDateLabel
                                inputDate={row.coverageStartDate}
                                dateFormat="MM/DD/YYYY"
                              />
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {row.warrantyStartDate && (
                              <JBWDateLabel
                                inputDate={row.warrantyStartDate}
                                dateFormat="MM/DD/YYYY"
                              />
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {row.warrantyEndDate && (
                              <JBWDateLabel
                                inputDate={row.warrantyEndDate}
                                dateFormat="MM/DD/YYYY"
                              />
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {row.isDeleted === 0 ? false : true}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>
              </Grid>
            )}
          {invoice.invoiceClaims && invoice.invoiceClaims.length > 0 && (
            <Grid item xs={12}>
              <Paper sx={{ width: "100%", mb: 1 }} elevation={3}>
                <Typography variant="subtitle1" sx={{ ml: 1, mb: 1 }}>
                  Claims For Job Number
                </Typography>
                <Table
                  sx={{ minWidth: 550 }}
                  size="small"
                  aria-label="Claims For Job Number"
                >
                  <TableHead sx={{ fontSize: "10px" }}>
                    <TableRow>
                      <TableCell>Jbw Claim Id</TableCell>
                      <TableCell align="left">JbwAgreementId</TableCell>
                      <TableCell align="left">Claim Status</TableCell>
                      <TableCell align="left">Claim Link</TableCell>
                      <TableCell align="left">Claim Amount</TableCell>
                      <TableCell align="left">Paid Amount</TableCell>
                      <TableCell align="left">Claim Filed Date</TableCell>
                      <TableCell align="left">Claim Status Date</TableCell>
                      <TableCell align="left">Ignore Invoice</TableCell>
                      <TableCell align="left">Is ClaimFiled</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoice.invoiceClaims.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.jbwClaimId}
                        </TableCell>
                        <TableCell align="left">{row.jbwAgreementId}</TableCell>
                        <TableCell align="left">{row.claimStatus}</TableCell>
                        <TableCell align="left">{row.claimLink}</TableCell>
                        <TableCell align="left">{row.claimAmount}</TableCell>
                        <TableCell align="left">{row.paidAmount}</TableCell>
                        <TableCell align="left">
                          {row.claimFiledDate && (
                            <JBWDateLabel
                              inputDate={row.claimFiledDate}
                              dateFormat="MM/DD/YYYY"
                            />
                          )}
                        </TableCell>

                        <TableCell align="left">
                          {row.claimStatusDate && (
                            <JBWDateLabel
                              inputDate={row.claimStatusDate}
                              dateFormat="MM/DD/YYYY"
                            />
                          )}
                        </TableCell>
                        <TableCell align="left">
                          {row.ignoreInvoice === 0 ? "No" : "Yes"}
                        </TableCell>
                        <TableCell align="left">
                          {row.isClaimFiled === 0 ? "No" : "Yes"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </Grid>
          )}
          {invoice.locationAgreements &&
            invoice.locationAgreements.length > 0 && (
              <Grid item xs={12}>
                <Paper sx={{ width: "100%", mb: 1 }} elevation={3}>
                  <Typography variant="subtitle1" sx={{ ml: 1, mb: 1 }}>
                    Agreements For this location
                    {needLocationAgreementSelection && (
                      <Typography
                        variant="caption"
                        color="warning.main"
                        sx={{ ml: 1 }}
                      >
                        — select one to proceed
                      </Typography>
                    )}
                  </Typography>
                  <Table
                    sx={{ minWidth: 550 }}
                    size="small"
                    aria-label="Agreements For this location"
                  >
                    <TableHead sx={{ fontSize: "10px" }}>
                      <TableRow>
                        <TableCell>Product Code</TableCell>
                        <TableCell align="left">JbwAgreementId</TableCell>
                        <TableCell align="left">Agreement Status</TableCell>
                        <TableCell align="left">Agreement Link</TableCell>
                        <TableCell align="left">Purchase Date</TableCell>
                        <TableCell align="left">Start Date</TableCell>
                        <TableCell align="left">Coverage Start Date</TableCell>
                        <TableCell align="left">Expiration Date</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {invoice.locationAgreements.map((row, index) => (
                        <TableRow
                          key={index}
                          onClick={
                            needLocationAgreementSelection
                              ? () => setSelectedLocationAgreement(row)
                              : undefined
                          }
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            ...(needLocationAgreementSelection && {
                              cursor: "pointer",
                              backgroundColor:
                                selectedLocationAgreement === row
                                  ? "#bbdefb"
                                  : "inherit",
                              "&:hover": { backgroundColor: "#e3f2fd" },
                            }),
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {row.productCode}
                          </TableCell>
                          <TableCell align="left">
                            {row.jbwAgreementId}
                          </TableCell>
                          <TableCell align="left">
                            {row.agreementStatus}
                          </TableCell>
                          <TableCell align="left">
                            {row.agreementLink}
                          </TableCell>
                          <TableCell align="left">
                            {row.purchaseDate && (
                              <JBWDateLabel
                                inputDate={row.purchaseDate}
                                dateFormat="MM/DD/YYYY"
                              />
                            )}
                          </TableCell>

                          <TableCell align="left">
                            {row.startDate && (
                              <JBWDateLabel
                                inputDate={row.startDate}
                                dateFormat="MM/DD/YYYY"
                              />
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {row.coverageStartDate && (
                              <JBWDateLabel
                                inputDate={row.coverageStartDate}
                                dateFormat="MM/DD/YYYY"
                              />
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {row.expirationDate && (
                              <JBWDateLabel
                                inputDate={row.expirationDate}
                                dateFormat="MM/DD/YYYY"
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>
              </Grid>
            )}
          <Grid item xs={12}>
            <Paper sx={{ width: "100%", mb: 1 }} elevation={3}>
              <Typography variant="subtitle1" sx={{ ml: 1, mb: 1 }}>
                Invoice Details
              </Typography>
              <Table
                sx={{ minWidth: 550 }}
                size="small"
                aria-label="Invoice Details table"
              >
                <TableHead sx={{ fontSize: "10px" }}>
                  <TableRow>
                    <TableCell>Dealer Id</TableCell>
                    <TableCell align="left">Tenant Id</TableCell>
                    <TableCell align="left">Job Number</TableCell>
                    <TableCell align="left">Summary</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Customer Name</TableCell>
                    <TableCell align="left">Phone & Email</TableCell>
                    <TableCell align="left">Address</TableCell>
                    <TableCell align="left">St Created On</TableCell>
                    <TableCell align="left">St Modified On</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    key={invoice.invoiceId}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {invoice.dealerId}
                    </TableCell>
                    <TableCell align="left">{invoice.tenantId}</TableCell>
                    <TableCell align="left">{invoice.jobNumber}</TableCell>
                    <TableCell align="left">{invoice.invoiceSummary}</TableCell>
                    <TableCell align="left">{invoice.invoiceStatus}</TableCell>
                    <TableCell align="left">
                      <Typography
                        variant="subtitl1"
                        component="span"
                        sx={{
                          wordWrap: "break-word",
                        }}
                        whiteSpace="normal"
                      >
                        {invoice.firstName + " " + invoice.lastName}
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Stack direction="row">
                        <Typography
                          variant="subtitl1"
                          component="span"
                          sx={{
                            wordWrap: "break-word",
                          }}
                          whiteSpace="normal"
                        >
                          {invoice.phoneNumber !== null &&
                          invoice.phoneNumber !== "null"
                            ? invoice.phoneNumber
                            : ""}
                        </Typography>
                        <br />
                        <Typography
                          variant="subtitl1"
                          component="span"
                          sx={{
                            wordWrap: "break-word",
                          }}
                          whiteSpace="normal"
                        >
                          {invoice.emailAddress !== null &&
                          invoice.emailAddress !== "null"
                            ? ", " + invoice.emailAddress
                            : ""}
                        </Typography>
                      </Stack>
                    </TableCell>
                    <TableCell align="left">
                      <Typography
                        variant="subtitl1"
                        component="span"
                        sx={{
                          wordWrap: "break-word",
                        }}
                        whiteSpace="normal"
                      >
                        {`${invoice.addressLine1} 
                        ${invoice.addressLine2 !== null && invoice.addressLine2 !== "null" ? ", " + invoice.addressLine2 : ""}
                        ${invoice.city !== null && invoice.city !== "null" ? ", " + invoice.city : ""} 
                        ${invoice.state !== null && invoice.state !== "null" ? ", " + invoice.state : ""} 
                        ${invoice.zipcode !== null && invoice.zipcode !== "null" ? ", " + invoice.zipcode : ""}.`}
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      {invoice.stCreatedOn && (
                        <JBWDateLabel
                          inputDate={invoice.stCreatedOn}
                          dateFormat="MM/DD/YYYY"
                        />
                      )}
                    </TableCell>
                    <TableCell align="left">
                      {invoice.stModifiedOn && (
                        <JBWDateLabel
                          inputDate={invoice.stModifiedOn}
                          dateFormat="MM/DD/YYYY"
                        />
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <TableContainer sx={{ maxHeight: 350 }} component={Paper}>
                <Table
                  sx={{ minWidth: 550 }}
                  size="small"
                  aria-label="Invoice Items table"
                  stickyHeader
                >
                  <TableHead sx={{ fontSize: "10px" }}>
                    <TableRow>
                      <TableCell
                        align="left"
                        sx={{ backgroundColor: "#bbdefb" }}
                      >
                        Item Id
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ backgroundColor: "#bbdefb" }}
                      >
                        Display Name
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ backgroundColor: "#bbdefb" }}
                      >
                        SKU Name
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ backgroundColor: "#bbdefb" }}
                      >
                        Manufacturer
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ backgroundColor: "#bbdefb" }}
                      >
                        Model Number
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ backgroundColor: "#bbdefb" }}
                      >
                        Serial Number
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ backgroundColor: "#bbdefb" }}
                      >
                        Quantity
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ backgroundColor: "#bbdefb" }}
                      >
                        Total Cost
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ backgroundColor: "#bbdefb" }}
                      >
                        Is Installed Equipment
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{ backgroundColor: "#bbdefb" }}
                      >
                        Is JbwPlan
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoice.invoiceItems ? (
                      invoice.invoiceItems.map((item, index) => (
                        <TableRow
                          key={item.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell align="left">
                            {item.invoiceItemId}
                          </TableCell>
                          <TableCell align="left">
                            {item.itemDisplayName}
                          </TableCell>
                          <TableCell align="left">{item.itemSKUName}</TableCell>
                          <TableCell align="left">
                            {item.manufacturer}
                          </TableCell>
                          <TableCell align="left">{item.modelNo}</TableCell>
                          <TableCell align="left">
                            {item.serialNumber}
                          </TableCell>
                          <TableCell align="left">{item.quantity}</TableCell>
                          <TableCell align="left">{item.totalCost}</TableCell>
                          <TableCell align="left">
                            {item.isInstalledEquipment === 0 ? "No" : "Yes"}
                          </TableCell>
                          <TableCell align="left">
                            {item.isJBWPlan === 0 ? "No" : "Yes"}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <Typography
                        variant="body"
                        component="span"
                        sx={{ color: "#f44336", fontSize: "14px" }}
                      >
                        No Invoice Items Available
                      </Typography>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "right" }}>
            {needInvoiceAgreementSelection && !selectedInvoiceAgreement && (
              <Typography
                variant="caption"
                color="warning.main"
                display="block"
                sx={{ mb: 1 }}
              >
                Select an agreement from "Agreements For Job Number" table above
                to enable the action.
              </Typography>
            )}
            {needLocationAgreementSelection && !selectedLocationAgreement && (
              <Typography
                variant="caption"
                color="warning.main"
                display="block"
                sx={{ mb: 1 }}
              >
                Select an agreement from "Agreements For this location" table
                above to enable the action.
              </Typography>
            )}
            {/* Condition 1: all null → Create Agreement */}
            {showCreateAgreement && (
              <Button
                variant="contained"
                size="medium"
                color="secondary"
                sx={{ mr: 2, borderRadius: "50px" }}
                startIcon={<ReceiptLongIcon size={20} />}
                onClick={onCreateAgreement}
              >
                Create Agreement
              </Button>
            )}
            {/* Conditions 2 & 5: invoiceAgreements present, no claims → Duplicate Agreement */}
            {showDuplicateAgreement && (
              <Button
                variant="contained"
                size="medium"
                color="secondary"
                sx={{ mr: 2, borderRadius: "50px" }}
                startIcon={<ReceiptLongIcon size={20} />}
                disabled={!duplicateAgreementEnabled}
                onClick={() => {
                  const agreement = multipleInvoiceAgreements
                    ? selectedInvoiceAgreement
                    : invoice.invoiceAgreements[0];
                  onDuplicateAgreement(agreement);
                }}
              >
                Create Duplicate Agreement
              </Button>
            )}
            {/* Condition 3: no invoiceAgreements, no claims, locationAgreements present → Create Potential Claim */}
            {showPotentialClaim && (
              <Button
                variant="contained"
                size="medium"
                color="success"
                sx={{ mr: 2, borderRadius: "50px" }}
                startIcon={<SiGoogleforms size={20} />}
                disabled={!potentialClaimEnabled}
                onClick={() => {
                  const locationAgreement = multipleLocationAgreements
                    ? selectedLocationAgreement
                    : invoice.locationAgreements[0];
                  console.log("Create Potential Claim", locationAgreement);
                  onCreatePotenitalClaim(locationAgreement);
                }}
              >
                Create Potential Claim
              </Button>
            )}
            {/* Condition 4: claims exist and locationAgreements present → Duplicate Claim */}
            {showDuplicateClaim && (
              <Button
                variant="contained"
                size="medium"
                color="success"
                sx={{ mr: 2, borderRadius: "50px" }}
                startIcon={<SiGoogleforms size={20} />}
                disabled={!duplicateClaimEnabled}
                onClick={() => {
                  const locationAgreement = multipleLocationAgreements
                    ? selectedLocationAgreement
                    : invoice.locationAgreements?.[0];
                  onDuplicateClaim(locationAgreement);
                }}
              >
                Duplicate Claim
              </Button>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
